export default __webpack_public_path__ + "static/media/4DE64B29-E75C-4A7E-9942-0930121C38D1.f1d98648.jpeg";